import { type ComponentProps, type ReactNode } from "react";
import { cn } from "ui";

export type StatusBadgeTone =
  | "green"
  | "amber"
  | "red"
  | "blue"
  | "sky"
  | "slate"
  | "muted";

const TONE_CLASS_NAMES: Record<StatusBadgeTone, string> = {
  green: "border-green-200 bg-green-50 text-green-700",
  amber: "border-amber-200 bg-amber-50 text-amber-700",
  red: "border-red-200 bg-red-50 text-red-700",
  blue: "border-blue-200 bg-blue-50 text-blue-700",
  sky: "border-sky-200 bg-sky-50 text-sky-700",
  slate: "border-slate-200 bg-slate-50 text-slate-600",
  muted: "border-border bg-muted text-muted-foreground",
};

interface StatusBadgeProps extends ComponentProps<"span"> {
  tone: StatusBadgeTone;
  icon?: ReactNode | null;
}

export function StatusBadge(props: StatusBadgeProps) {
  const { tone, icon, className, children, ...rest } = props;

  return (
    <span
      {...rest}
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium",
        TONE_CLASS_NAMES[tone],
        className,
      )}
    >
      {icon === undefined ? (
        <span className="size-1.5 rounded-full bg-current" />
      ) : (
        icon
      )}
      {children}
    </span>
  );
}
